export const SearchControllerFactory = ({
  searchService,
}: {
  searchService: ISearchService;
}) => {
  const getSearch: IGetSearch = async (payload) => {
    if (payload.patientIds?.length === 0 || payload.search === null) {
      return { success: false };
    }
    const { success, data } = await searchService.getSearch(payload);
    if (success && data && data.data.length) {
      return { success: true, data: data };
    }
    return { success: false, error: { message: "error" } };
  };

  const getAllPatientList: IGetAllPatientList = async (payload) => {
    if (payload.clinicId === 0) {
      return { success: false, error: { message: "error" } };
    }
    const { success, data } = await searchService.getAllPatientList(payload);
    if (success && data && data.length) {
      return { success: true, data: data };
    }
    return { success: false, error: { message: "error" } };
  };

  const getAllPatientListV2: IGetAllPatientListV2 = async (payload) => {
    if (payload.clinicId === 0) {
      return { success: false, error: { message: "error" } };
    }
    const { success, data } = await searchService.getAllPatientListV2(payload);
    if (success && data && data.length) {
      return { success: true, data: data };
    }
    return { success: false, error: { message: "error" } };
  };

  const getIPVNotesPatientsListV3: IGetIPVNotesPatientsListV3 = async (
    payload
  ) => {
    if (payload.clinicId === 0) {
      return { success: false, error: { message: "error" } };
    }
    const { success, data } = await searchService.getIPVNotesPatientsListV3(
      payload
    );
    if (success && data) {
      return { success: true, data: data };
    }
    return { success: false, error: { message: "error" } };
  };

  return {
    getSearch,
    getAllPatientList,
    getAllPatientListV2,
    getIPVNotesPatientsListV3,
  };
};
